import { useTranslations } from 'next-intl';

import Collapsible from '@commons/components/Collapsible';
import Link from '@commons/components/Link';
import Text from '@commons/components/Text';
import Flex from '@commons/containers/Flex';

import type { GardaWorldBusiness } from '.';

type Props = {
  businesses: readonly GardaWorldBusiness[];
};

/**
 * GardaWorld Footer BusinessMenuMobile component.
 */

const BusinessMenuMobile = ({ businesses }: Props) => {
  const t = useTranslations('footer');

  const renderedTitle = (
    <Text level="h4" weight="normal" marginBottom="none">
      {t('ourBusinesses')}
    </Text>
  );

  const renderedLinks = businesses.map((business) => (
    <Link reverse href={t(`links.${business}.url`)} level="h5" key={business}>
      {t(`links.${business}.text`)}
    </Link>
  ));

  return (
    <Collapsible title={renderedTitle} hasBorderTop={false}>
      <Flex gap="xs" direction="column">
        {renderedLinks}
      </Flex>
    </Collapsible>
  );
};

export default BusinessMenuMobile;
